<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg style="height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#recycle-car"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title text-color-red2" >Очистить раздел «Удалённые»?</div>

              <p class="info-text mt16 text-color-red2">
                  Это действие реально нельзя отменить.
              </p>
          </div>

          <div class="mt24">
              <submit-btn @click.native="remove" :type="btnType"><span class="i i-ok7 mr8"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "RemoveRules",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            remove(){
                this.btnType = 'load';
                this.$store.dispatch('rules/removeRuleAll', {
                id: this.item.id,
                forever: true,
                section: this.activeTopSection,
                }).then(()=>{
                    this.btnType = 'normal';
                    this.$store.commit('popups/close', {name: this.popups.removeRules.name});
                    this.$router.push('/');
                });
            },
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.removeRules.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.editItem,
                topSections: state => state.rules.topSections,
            }),
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
